export default "__VITE_ASSET__BxT7ehcd__"